<template>
  <div class="TycProducts" >
    <el-divider content-position="left">产品管理</el-divider>
    <el-row>
      <el-col :span="24" class="tr">
        <el-button type="primary" size="mini" @click="handelAddOpen">录入</el-button>
      </el-col>
    </el-row>
    <el-table :data="pageData" size="mini" border style="width: 100%; margin-top: .2rem" v-cloak>
      <el-table-column label="产品名称" prop="name"></el-table-column>
      <el-table-column label="初始价格" prop="origin_price"></el-table-column>
      <el-table-column label="销售价格" prop="price"></el-table-column>
      <el-table-column label="周期类型" prop="cycle_type"></el-table-column>
      <el-table-column label="纳税规模" prop="scale_type"></el-table-column>
      <el-table-column label="分类" prop="type"></el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" content="编辑" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="handleEditOpen(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item"  effect="dark" content="删除" placement="top">
            <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handleDel(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="tr mt-10"
      layout="total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-drawer
      title="录入"
      :visible.sync="addDrawer"
      direction="rtl"
      :before-close="handleAddBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form ref="addFrom" :rules="addRules" :model="addFrom" label-width="110px" size="mini">
          <el-form-item label="产品名称" prop="name">
            <el-input v-model="addFrom.name"></el-input>
          </el-form-item>
          <el-form-item label="初始价格" prop="price">
            <el-input v-model="addFrom.origin_price"></el-input>
          </el-form-item>
          <el-form-item label="销售价格" prop="price">
            <el-input v-model="addFrom.price"></el-input>
          </el-form-item>
          <el-form-item label="周期" prop="cycle_type">
            <el-select v-model="addFrom.cycle_type" placeholder="请选择周期">
              <el-option label="1个月" :value="1"></el-option>
              <el-option label="2个月" :value="2"></el-option>
              <el-option label="3个月" :value="3"></el-option>
              <el-option label="4个月" :value="4"></el-option>
              <el-option label="5个月" :value="5"></el-option>
              <el-option label="6个月" :value="6"></el-option>
              <el-option label="7个月" :value="7"></el-option>
              <el-option label="8个月" :value="8"></el-option>
              <el-option label="9个月" :value="9"></el-option>
              <el-option label="10个月" :value="10"></el-option>
              <el-option label="11个月" :value="11"></el-option>
              <el-option label="12个月" :value="12"></el-option>
              <el-option label="24个月" :value="24"></el-option>
              <el-option label="36个月" :value="36"></el-option>
              <el-option label="48个月" :value="48"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="纳税规模" prop="scale_type">
            <el-select v-model="addFrom.scale_type" placeholder="请选择纳税规模">
              <el-option label="纯零申报" :value="5"></el-option>
              <el-option label="小规模有票" :value="6"></el-option>
              <el-option label="一般纳税人有票" :value="7"></el-option>
              <el-option label="小规模纳税人（无票）" :value="1"></el-option>
              <el-option label="小规模纳税人（有票）" :value="2"></el-option>
              <el-option label="一般纳税人（无票）" :value="3"></el-option>
              <el-option label="一般纳税人（有票）" :value="4"></el-option>
              <el-option label="纯零申报-" :value="8"></el-option>
              <el-option label="小规模有票-" :value="9"></el-option>
              <el-option label="一般纳税人有票-" :value="10"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类" prop="type">
            <el-select v-model="addFrom.type" placeholder="请选择分类">
              <el-option label="代理记账" :value="1"></el-option>
              <el-option label="增值服务" :value="2"></el-option>
              <el-option label="公司注册" :value="3"></el-option>
              <el-option label="其他服务" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-row class="mt-10 tr">
          <el-button type="primary" size="mini" @click="submitAdd('addFrom')">录 入</el-button>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="编辑"
      :visible.sync="upDrawer"
      direction="rtl"
      :before-close="handleUpBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form ref="upFrom" :rules="upRules" :model="upFrom" label-width="110px" size="mini">
          <el-form-item label="产品名称" prop="name">
            <el-input v-model="upFrom.name"></el-input>
          </el-form-item>
          <el-form-item label="初始价格" prop="price">
            <el-input v-model="upFrom.origin_price"></el-input>
          </el-form-item>
          <el-form-item label="销售价格" prop="price">
            <el-input v-model="upFrom.price"></el-input>
          </el-form-item>
          <el-form-item label="周期" prop="cycle_type">
            <el-select v-model="upFrom.cycle_type" placeholder="请选择周期">
              <el-option label="1个月" value="1个月"></el-option>
              <el-option label="2个月" value="2个月"></el-option>
              <el-option label="3个月" value="3个月"></el-option>
              <el-option label="4个月" value="4个月"></el-option>
              <el-option label="5个月" value="5个月"></el-option>
              <el-option label="6个月" value="6个月"></el-option>
              <el-option label="7个月" value="7个月"></el-option>
              <el-option label="8个月" value="8个月"></el-option>
              <el-option label="9个月" value="9个月"></el-option>
              <el-option label="10个月" value="10个月"></el-option>
              <el-option label="11个月" value="11个月"></el-option>
              <el-option label="12个月" value="12个月"></el-option>
              <el-option label="24个月" value="24个月"></el-option>
              <el-option label="36个月" value="36个月"></el-option>
              <el-option label="48个月" value="48个月"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="纳税规模" prop="scale_type">
            <el-select v-model="upFrom.scale_type" placeholder="请选择纳税规模">
              <el-option label="纯零申报" value="纯零申报"></el-option>
              <el-option label="小规模有票" value="小规模有票"></el-option>
              <el-option label="一般纳税人有票" value="一般纳税人有票"></el-option>
              <el-option label="小规模纳税人（无票）" value="小规模纳税人（无票）"></el-option>
              <el-option label="小规模纳税人（有票）" value="小规模纳税人（有票）"></el-option>
              <el-option label="一般纳税人（无票）" value="一般纳税人（无票）"></el-option>
              <el-option label="一般纳税人（有票）" value="一般纳税人（有票）"></el-option>
              <el-option label="纯零申报-" value="纯零申报-"></el-option>
              <el-option label="小规模有票-" value="小规模有票-"></el-option>
              <el-option label="一般纳税人有票-" value="一般纳税人有票-"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类" prop="type">
            <el-select v-model="upFrom.type" placeholder="请选择分类">
              <el-option label="代理记账" value="代理记账"></el-option>
              <el-option label="增值服务" value="增值服务"></el-option>
              <el-option label="公司注册" value="公司注册"></el-option>
              <el-option label="其他服务" value="其他服务"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-row class="mt-10 tr">
          <el-button type="primary" size="mini" @click="submitUpdate('upFrom')">保 存</el-button>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'TycProducts',
  data () {
    return {

      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 10 // 每页显示条数
      },
      searchArr: {
        name: ''
      },
      addDrawer: false,
      addFrom: {
        name: '',
        origin_price: 0,
        price: 0,
        cycle_type: '',
        scale_type: '',
        type: ''
      },
      addRules: {
        name: [
          { required: true, message: '产品名称不能为空', trigger: 'blur' }
        ],
        origin_price: [
          { required: true, message: '初始价格不能为空', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '产品价格不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '分类不能为空', trigger: 'blur' }
        ]
      },
      upDrawer: false,
      upFrom: {
        id: '',
        name: '',
        origin_price: 0,
        price: 0,
        cycle_type: '',
        scale_type: '',
        type: ''
      },
      upRules: {
        name: [
          { required: true, message: '产品名称不能为空', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '产品价格不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '分类不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getPageData () {
      this.$axios.get('/api/admin/tyc_products?page=' + this.pageOption.currentPage)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.pageData = data.data.pageData.data
            this.pageOption.total = data.data.pageData.total
          }
        })
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getPageData()
    },
    handelAddOpen () {
      this.addDrawer = true
    },
    handleAddBeforeClose (done) {
      this.$refs['addFrom'].resetFields()
      done()
    },
    submitAdd (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post('/api/admin/tyc_products', this.addFrom)
            .then((res) => {
              let { data } = res
              if (data.code === 0) {
                this.addDrawer = false
                this.$refs['addFrom'].resetFields()
                this.$message.success(data.msg)
                this.getPageData()
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    handleEditOpen (row) {
      this.upFrom.id = row.id
      this.upFrom.name = row.name
      this.upFrom.origin_price = row.origin_price
      this.upFrom.price = row.price
      this.upFrom.cycle_type = row.cycle_type
      this.upFrom.scale_type = row.scale_type
      this.upFrom.type = row.type
      this.upDrawer = true
    },
    handleUpBeforeClose (done) {
      this.upFrom.id = ''
      this.$refs['upFrom'].resetFields()
      done()
    },
    submitUpdate (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post('/api/admin/tyc_products/update', this.upFrom)
            .then((res) => {
              let { data } = res
              if (data.code === 0) {
                this.upFrom.id = ''
                this.$refs['upFrom'].resetFields()
                this.upDrawer = false
                this.$message.success(data.msg)
                this.getPageData()
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    handleDel (row) {
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/api/admin/tyc_products/del', {id: row.id})
          .then((res) => {
            let { data } = res
            if (data.code === 0) {
              this.$message.success(data.msg)
              this.getPageData()
            } else {
              this.$message.error(data.msg)
            }
          })
      }).catch(() => {})
    }
  },
  mounted () {
    this.getPageData()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-form .el-select
  width: 100%
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-drawer .el-form-item
  margin-bottom: .3rem !important
.el-timeline >>> .el-timeline-item__content
  line-height: 1.7
  margin-bottom: .3rem !important
.TycProducts >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.TycProducts
  marginLeft()
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.tr
  text-align: right
.text-align-c
  text-align: center
.mt-10
  margin-top: .2rem
</style>



// WEBPACK FOOTER //
// src/pages/tyc_products/TycProducts.vue